import React from 'react'
import { useQuery } from '@apollo/client'
import { useMediaQuery, useTheme } from '@material-ui/core'
import GET_TAX_EXEMPTION_STATUS from 'Apollo/Queries/GetTaxExemptionStatus'
import { useAppState } from 'Context/AppContext/AppContext'
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { TaxExemptionStatusQuery } from 'TypeDefs/TaxExemptionStatusTracker'
import DesktopOnlyView from 'Components/SharedComponents/DesktopOnlyView/DesktopOnlyView'
import PageWrapper from 'Components/SharedComponents/PageWrapper/PageWrapper'
import TaxExemptionStatusContainer from '../TaxExemptionStatusTrackerContainer/TaxExemptionStatusTrackerContainer'

const FormationDashboardContainer = () => {
  const theme = useTheme()
  const isScreenLarge = useMediaQuery(theme.breakpoints.up('md'))
  const {
    nonprofitOrgConfig: { orgId },
  } = useAppState()

  const { data, loading } = useQuery<TaxExemptionStatusQuery>(
    GET_TAX_EXEMPTION_STATUS,
    { variables: { nonprofitOrgId: orgId }, skip: !orgId }
  )

  if (!isScreenLarge)
    return (
      <PageWrapper>
        <DesktopOnlyView pageTitle='Formation' />
      </PageWrapper>
    )

  return (
    <PageWrapper>
      <TaxExemptionStatusContainer loading={loading} data={data} />
    </PageWrapper>
  )
}
export default WithPermission(
  FormationDashboardContainer,
  ['page:formation'],
  true
)
